<template>
  <Container class="container-sm-none">
    <Progressbar :step="6" :step-count="model.stepCount">
      Current Source of Income
    </Progressbar>
    <Card class="card-shadow">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">

          <Collapse
            v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
            :key="index + 1"
            :opened-index="openedIndex"
            @change="setOpened"
            @handle-next-step="handleNextStep"
            @child-loaded="handleCollapseLoaded"
            :tried-go-to-next-step="triedGoToNextStep"
            :index="index"
            :model="model"
            :disabled="!person.isAdult"
            :person-count="model.insuredPersons.array_hd7ov6$_0.length"
            :errors="errors"
          >
            <template v-slot:title>
              <p v-if="person.name && person.surname">
                {{`${person.name} ${person.surname}`}}
              </p>
              <p v-else>
                Policyholder {{`${index + 1}`}}
              </p>
            </template>
            <IncomeSource
              v-if="person.isAdult"
              :index="index"
              :errors="errors"
              :model="model"
              :person="person"
            />
          </Collapse>

          <ButtonGroup class="pt-10">
            <Button
              class="btn-outline-tertiary w-full"
              :icon-left="require('@/assets/svg/icon-left-gray.svg')"
              @click="redirectBack"
            >
              Back
            </Button>
            <Button
              class="btn-primary w-full"
              :icon-right="require('@/assets/svg/icon-right-white.svg')"
              @click="redirectToNext"
              v-scroll-to-error
            >
              Continue
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Button from '@/components/Button/Button.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import routes from '@/mixins/routes';
import IncomeSource from '@/pagesComponents/IncomeSource.vue';
import lead from '@/mixins/lead';
import Collapse from '@/components/Collapse/Collapse.vue';
import GA from '@/mixins/GA';

export default {
  name: 'IncomeSourcePage',
  mixins: [routes, lead, GA],
  data() {
    return {
      openedIndex: -1,
      triedGoToNextStep: false,
    };
  },
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
  },
  components: {
    Collapse,
    IncomeSource,
    ButtonGroup,
    Button,
    Card,
    Container,
    Progressbar,
  },
  methods: {
    redirectToNext() {
      this.triedGoToNextStep = true;
      if (this.errors.length === 0) {
        this.saveLead(this.getNearestNextAvailableStep());
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
    handleCollapseLoaded() {
      this.openedIndex = this.model.currentPersonIndex;
    },
    handleNextStep() {
      this.triedGoToNextStep = false;
    },
    setOpened(index) {
      this.openedIndex = index;
    },
  },
  created() {
    this.model.step = 7;
    if (this.model.lastStep < 7) this.model.lastStep = 7;
  },
  mounted() {
    this.funnelStep('Aktuálny zdroj príjmu');
  },
};
</script>
